import { call, fork, put, takeEvery } from 'redux-saga/effects';
import CouponApi from '../../../lib/api/coupon/CouponApi';
import toastMsg from '../../../lib/toastMsg';
import {
  _setResponseListForm,
  excelDownLoad,
  reDirectPage,
  setDetailPageUrl,
  setMultipartForm,
  setRequestForm,
  setResponseListForm,
} from '../../../lib/common';
import couponAction from './actions';
import couponToastMsg from '../../../constants/service/toastMsg/couponToastMsg';
import appActions from '../app/actions';
import { setApplyCouponDiscount } from '../../../lib/utils/couponUtils';
import { COUPON_DETAIL_URL_PATH } from '../../../constants/service/common/urlConstants';
import { COUPON_AVAILABLE_TYPE } from '../../../constants/service/app/couponConstants';

function* fetchList() {
  /**
   *  [쿠폰 리스트] 쿠폰 리스트 요청하기
   */
  yield takeEvery(couponAction.GET_COUPON_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_LIST_REQUEST_SUCCESS);

        const data = {
          couponList: setResponseListForm(result.data.couponList, result.data.totalCnt, payload),
        };
        yield put({ type: couponAction.GET_COUPON_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 리스트] 쿠폰 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(couponAction.GET_COUPON_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_LIST_REQUEST_SUCCESS);

        excelDownLoad('쿠폰 리스트', result.data.couponListExcelSheet);
      }
    } catch (error) {
      toastMsg.error(error.message || couponToastMsg.GET_COUPON_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 생성] 쿠폰 생성하기
   */
  yield takeEvery(couponAction.INSERT_COUPON_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.insertCoupon, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.INSERT_COUPON_REQUEST_SUCCESS);
        /**
         *  쿠폰 생성 완료 후 상세페이지로 이동
         */
        reDirectPage({ path: setDetailPageUrl(COUPON_DETAIL_URL_PATH, result.data.couponId) });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.INSERT_COUPON_REQUEST_ERROR, error);
    }
  });

  /**
   *  [쿠폰 생성] 쿠폰 별 쿠폰 적용 가능 상품 아이템 리스트 요청하기
   */
  yield takeEvery(couponAction.GET_COUPON_PRODUCT_ITEM_REQUEST, function* ({ payload }) {
    try {
      const {
        filterOption,
        sortOption,
        pagination,
        isSelectedProductClear,
        minimumPurchasePrice,
        discountType,
        discountAmount,
        maxDiscountPrice,
      } = payload;
      const result = yield call(
        CouponApi.getCouponProductItemList,
        setRequestForm(
          {
            filterOption,
            sortOption,
            pagination,
            minimumPurchasePrice,
            discountType,
            discountAmount,
            maxDiscountPrice,
          },
          true,
        ),
      );
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_PRODUCT_ITEM_REQUEST_SUCCESS);

        const data = {
          couponProductLinkInfo: _setResponseListForm(
            result.data.couponProductLinkInfo.list,
            result.data.couponProductLinkInfo.totalCnt,
            { filterOption, sortOption, pagination },
          ),
          mainProductCategorySelectList: result.data.mainProductCategorySelectList,
          subProductCategorySelectList: result.data.subProductCategorySelectList,
          isSelectedProductClear,
        };

        yield put({ type: couponAction.GET_COUPON_PRODUCT_ITEM_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_PRODUCT_ITEM_REQUEST_ERROR, error);
    }
  });

  /**
   *  [쿠폰 생성] 쿠폰 별 쿠폰 적용 가능 브랜드 아이템 리스트 요청하기
   */
  yield takeEvery(couponAction.GET_COUPON_BRAND_ITEM_REQUEST, function* ({ payload }) {
    try {
      const {
        filterOption,
        pagination,
        isSelectedBrandClear,
        minimumPurchasePrice,
        discountType,
        discountAmount,
        maxDiscountPrice,
        exclude24k,
      } = payload;
      const result = yield call(
        CouponApi.getCouponBrandItemList,
        setRequestForm(
          {
            filterOption,
            pagination,
            minimumPurchasePrice,
            discountType,
            discountAmount,
            maxDiscountPrice,
            exclude24k,
          },
          true,
        ),
      );
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_BRAND_ITEM_REQUEST_SUCCESS);

        const data = {
          couponBrandLinkInfo: _setResponseListForm(
            result.data.couponBrandLinkInfo.list,
            result.data.couponBrandLinkInfo.totalCnt,
            { filterOption, pagination },
          ),
          isSelectedBrandClear,
        };

        yield put({ type: couponAction.GET_COUPON_BRAND_ITEM_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_BRAND_ITEM_REQUEST_ERROR, error);
    }
  });

  /**
   *  [쿠폰 생성] 전체 상품 리스트 EXCEL 다운로드
   */
  yield takeEvery(couponAction.GET_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponProductItemListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('상품 아이템 리스트', result.data.couponProductItemExcelSheet);
      }
    } catch (error) {
      toastMsg.error(error.message || couponToastMsg.GET_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [쿠폰 생성] 전체 브랜드 리스트 EXCEL 다운로드
   */
  yield takeEvery(couponAction.GET_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponBrandItemListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('브랜드 아이템 리스트', result.data.couponBrandItemExcelSheet);
      }
    } catch (error) {
      toastMsg.error(error.message || couponToastMsg.GET_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [쿠폰 생성] 선택된 상품 리스트 EXCEL 다운로드
   */
  yield takeEvery(couponAction.GET_SELECTED_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getSelectedCouponProductItemListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_SELECTED_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('상품 아이템 리스트', result.data.selectedCouponProductItemExcelSheet);
      }
    } catch (error) {
      toastMsg.error(
        error.message || couponToastMsg.GET_SELECTED_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
        error,
      );
    }
  });

  /**
   *  [쿠폰 생성] 선택된 브랜드 리스트 EXCEL 다운로드
   */
  yield takeEvery(couponAction.GET_SELECTED_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getSelectedCouponBrandItemListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_SELECTED_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('브랜드 아이템 리스트', result.data.selectedCouponBrandItemExcelSheet);
      }
    } catch (error) {
      toastMsg.error(
        error.message || couponToastMsg.GET_SELECTED_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
        error,
      );
    }
  });

  /**
   *  [쿠폰 생성] 상품 리스트 엑셀 업로드 유효성 체크
   */
  yield takeEvery(couponAction.CHECK_VALID_COUPON_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.checkValidCouponProductItemListExcelUpload, setMultipartForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.CHECK_VALID_COUPON_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS);

        const { requestCnt, possibleCnt, impossibleCnt } = result.data;
        let { productList } = result.data;

        /**
         *  실패건이 하나라도 있는 경우에는 실패 모달로 보낸다.
         */
        if (impossibleCnt > 0) {
          /**
           *  쿠폰 사용 가능한 상품 유효성 검사 실패 모달 띄우기
           */
          yield put(
            couponAction.toggleModal({
              name: 'excelUploadCouponProductValidFailModal',
              value: true,
              data: {
                productList,
                requestCnt,
                possibleCnt,
                impossibleCnt,
              },
            }),
          );
        } else {
          /**
           *  리스트에 쿠폰 적용 가격, 쿠폰 적용 할인액 속성 넣기
           */
          productList = setApplyCouponDiscount(productList, payload.discountType, payload.discountAmount);

          /**
           *  쿠폰 사용 가능한 상품 유효성 검사 성공 모달 띄우기
           */
          yield put(
            couponAction.toggleModal({
              name: 'excelUploadCouponProductValidSuccessModal',
              value: true,
              data: {
                productList,
                requestCnt,
                possibleCnt,
                impossibleCnt,
              },
            }),
          );
        }
      }
    } catch (error) {
      toastMsg.error(
        error.message || couponToastMsg.CHECK_VALID_COUPON_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR,
        error,
      );
    }
  });

  /**
   *  [쿠폰 생성] 브랜드 리스트 EXCEL 업로드 유효성 체크
   */
  yield takeEvery(couponAction.CHECK_VALID_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.checkValidCouponBrandItemListExcelUpload, setMultipartForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.CHECK_VALID_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS);
      }

      const { brandList, requestCnt, possibleCnt, impossibleCnt } = result.data;

      /**
       *  실패건이 하나라도 있는 경우에는 실패 모달로 보낸다.
       */
      if (impossibleCnt > 0) {
        /**
         *  쿠폰 사용 가능한 브랜드 유효성 검사 실패 모달 띄우기
         */
        yield put(
          couponAction.toggleModal({
            name: 'excelUploadCouponBrandValidFailModal',
            value: true,
            data: {
              brandList,
              requestCnt,
              possibleCnt,
              impossibleCnt,
            },
          }),
        );
      } else {
        /**
         *  쿠폰 사용 가능한 브랜드 유효성 검사 성공 모달 띄우기
         */
        yield put(
          couponAction.toggleModal({
            name: 'excelUploadCouponBrandValidSuccessModal',
            value: true,
            data: {
              brandList,
              requestCnt,
              possibleCnt,
              impossibleCnt,
            },
          }),
        );
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.CHECK_VALID_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [쿠폰 생성] 해당 브랜드에서 쿠폰 적용 가능 상품 리스트 가져오기
   */
  yield takeEvery(couponAction.GET_COUPON_APPLY_AVAILABLE_PRODUCT_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponApplyAvailableProductList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_APPLY_AVAILABLE_PRODUCT_LIST_REQUEST_SUCCESS);

        const data = {
          listData: setResponseListForm(result.data.couponApplyAvailableProductList, result.data.totalCnt, payload),
          discountAmount: payload.discountAmount,
          discountType: payload.discountType,
          maxDiscountPrice: payload.maxDiscountPrice,
        };

        yield put({ type: couponAction.GET_COUPON_APPLY_AVAILABLE_PRODUCT_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_APPLY_AVAILABLE_PRODUCT_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [쿠폰 편집] 쿠폰 정보 가져오기
   */
  yield takeEvery(couponAction.GET_COUPON_INFO_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponInfo, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_INFO_REQUEST_SUCCESS);

        let data = {
          couponInfo: result.data.couponInfo,
        };

        /**
         *  쿠폰 유형에 따라 데이터 추가해주는게 다르다
         */
        if (data.couponInfo.availableType === COUPON_AVAILABLE_TYPE.TARGET_PRODUCT_COUPON) {
          data = {
            ...data,
            couponProductLinkInfo: {
              itemList: _setResponseListForm(
                result.data.couponProductLinkInfo.itemList.list,
                result.data.couponProductLinkInfo.totalCnt,
                payload.couponProductLink,
              ),
              selectedItemList: result.data.couponProductLinkInfo.selectedItemList,
              selectedItemBrandCount: result.data.couponProductLinkInfo.selectedItemBrandCount,
            },
            mainProductCategorySelectList: result.data.mainProductCategorySelectList,
            subProductCategorySelectList: result.data.subProductCategorySelectList,
          };
        } else if (data.couponInfo.availableType === COUPON_AVAILABLE_TYPE.TARGET_BRAND_COUPON) {
          data = {
            ...data,
            couponBrandLinkInfo: {
              itemList: _setResponseListForm(
                result.data.couponBrandLinkInfo.itemList.list,
                result.data.couponBrandLinkInfo.totalCnt,
                payload.couponBrandLink,
              ),
              selectedItemList: result.data.couponBrandLinkInfo.selectedItemList,
            },
          };
        }

        yield put({ type: couponAction.GET_COUPON_INFO_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_INFO_REQUEST_ERROR, error);
    }
  });

  /**
   *  [쿠폰 복사] 쿠폰 정보 가져오기
   */
  yield takeEvery(couponAction.GET_COUPON_COPY_INFO_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponInfo, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_INFO_REQUEST_SUCCESS);

        let data = {
          couponInfo: result.data.couponInfo,
        };

        /**
         *  쿠폰 유형에 따라 데이터 추가해주는게 다르다
         */
        if (data.couponInfo.availableType === COUPON_AVAILABLE_TYPE.TARGET_PRODUCT_COUPON) {
          data = {
            ...data,
            couponProductLinkInfo: {
              itemList: _setResponseListForm(
                result.data.couponProductLinkInfo.itemList.list,
                result.data.couponProductLinkInfo.totalCnt,
                payload.couponProductLink,
              ),
              selectedItemList: result.data.couponProductLinkInfo.selectedItemList,
            },
            mainProductCategorySelectList: result.data.mainProductCategorySelectList,
            subProductCategorySelectList: result.data.subProductCategorySelectList,
          };
        } else if (data.couponInfo.availableType === COUPON_AVAILABLE_TYPE.TARGET_BRAND_COUPON) {
          data = {
            ...data,
            couponBrandLinkInfo: {
              itemList: _setResponseListForm(
                result.data.couponBrandLinkInfo.itemList.list,
                result.data.couponBrandLinkInfo.totalCnt,
                payload.couponBrandLink,
              ),
              selectedItemList: result.data.couponBrandLinkInfo.selectedItemList,
            },
          };
        }

        yield put({ type: couponAction.GET_COUPON_COPY_INFO_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_INFO_REQUEST_ERROR, error);
    }
  });

  /**
   *  [쿠폰 편집] 쿠폰 편집 요청하기
   */
  yield takeEvery(couponAction.EDIT_COUPON_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.editCoupon, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.EDIT_COUPON_REQUEST_SUCCESS);
        /**
         *  편집 완료 후 상세페이지로 이동
         */
        reDirectPage({ path: setDetailPageUrl(COUPON_DETAIL_URL_PATH, payload.couponId) });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.EDIT_COUPON_REQUEST_ERROR, error);
    }
  });

  /**
   *  [쿠폰 상세] 쿠폰 상세 가져오기
   */
  yield takeEvery(couponAction.GET_COUPON_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_DETAIL_REQUEST_SUCCESS);

        let data = {
          couponInfo: result.data.couponInfo,
          couponStatistics: result.data.couponStatistics,
          couponUsageHistory: setResponseListForm(
            result.data.couponUsageHistory.couponUsageHistoryList,
            result.data.couponUsageHistory.totalCnt,
            payload.couponUsageHistory,
          ),
          couponUnUsageHistory: _setResponseListForm(
            result.data.couponUnUsageHistory.couponUnUsageHistoryList,
            result.data.couponUnUsageHistory.totalCnt,
            payload.couponUnUsageHistory,
          ),
        };

        /**
         *  쿠폰 유형에 따라 데이터 추가해주는게 다르다
         */
        if (data.couponInfo.availableType === COUPON_AVAILABLE_TYPE.TARGET_PRODUCT_COUPON) {
          data = {
            ...data,
            couponProductLink: _setResponseListForm(
              result.data.couponProductLink.couponProductLinkList,
              result.data.couponProductLink.totalCnt,
              payload.couponProductLink,
            ),
            mainProductCategorySelectList: result.data.mainProductCategorySelectList,
            subProductCategorySelectList: result.data.subProductCategorySelectList,
          };
        } else if (data.couponInfo.availableType === COUPON_AVAILABLE_TYPE.TARGET_BRAND_COUPON) {
          data = {
            ...data,
            couponBrandLink: _setResponseListForm(
              result.data.couponBrandLink.couponBrandLinkList,
              result.data.couponBrandLink.totalCnt,
              payload.couponBrandLink,
            ),
          };
        }

        yield put({ type: couponAction.GET_COUPON_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_DETAIL_REQUEST_ERROR, error);
    }
  });

  /**
   *  [쿠폰 상세] 쿠폰 사용내역 리스트 요청하기
   */
  yield takeEvery(couponAction.GET_COUPON_USAGE_HISTORY_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponUsageHistoryList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_USAGE_HISTORY_LIST_REQUEST_SUCCESS);

        const data = {
          couponUsageHistory: setResponseListForm(result.data.couponUsageHistoryList, result.data.totalCnt, payload),
        };
        yield put({ type: couponAction.GET_COUPON_USAGE_HISTORY_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_USAGE_HISTORY_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 상세] 쿠폰 사용내역 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(couponAction.GET_COUPON_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponUsageHistoryListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('쿠폰 사용내역 리스트', result.data.couponUsageHistoryListExcelSheet);
      }
    } catch (error) {
      toastMsg.error(error.message || couponToastMsg.GET_COUPON_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 상세] 쿠폰 미사용내역 리스트 요청하기
   */
  yield takeEvery(couponAction.GET_COUPON_UN_USAGE_HISTORY_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponUnUsageHistoryList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_UN_USAGE_HISTORY_LIST_REQUEST_SUCCESS);

        const data = {
          couponUnUsageHistory: _setResponseListForm(
            result.data.couponUnUsageHistoryList,
            result.data.totalCnt,
            payload,
          ),
        };

        yield put({ type: couponAction.GET_COUPON_UN_USAGE_HISTORY_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_UN_USAGE_HISTORY_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 상세] 쿠폰 미사용내역 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(couponAction.GET_COUPON_UN_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponUnUsageHistoryListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_UN_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('쿠폰 미사용내역 리스트', result.data.couponUnUsageHistoryListExcelSheet);
      }
    } catch (error) {
      toastMsg.error(
        error.message || error.messagecouponToastMsg.GET_COUPON_UN_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
      );
    }
  });

  /**
   *  [쿠폰 상세] 쿠폰별 쿠폰 적용 가능 상품 정보 가져오기
   */
  yield takeEvery(couponAction.GET_COUPON_PRODUCT_LINK_LIST_REQUEST, function* ({ payload }) {
    try {
      const { couponId, discountType, discountAmount, maxDiscountPrice, filterOption, pagination } = payload;
      const result = yield call(
        CouponApi.getCouponProductLinkList,
        setRequestForm({ couponId, filterOption, pagination }, true),
      );
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_PRODUCT_LINK_LIST_REQUEST_SUCCESS);

        const data = {
          couponProductLink: _setResponseListForm(result.data.couponProductLinkList, result.data.totalCnt, payload),
          discountAmount,
          discountType,
          maxDiscountPrice,
        };

        yield put({ type: couponAction.GET_COUPON_PRODUCT_LINK_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_PRODUCT_LINK_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 상세] 쿠폰별 적용 가능 브랜드 정보 가져오기
   */
  yield takeEvery(couponAction.GET_COUPON_BRAND_LINK_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponBrandLinkList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_BRAND_LINK_LIST_REQUEST_SUCCESS);

        const data = {
          couponBrandLink: _setResponseListForm(result.data.couponBrandLinkList, result.data.totalCnt, payload),
        };

        yield put({ type: couponAction.GET_COUPON_BRAND_LINK_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_BRAND_LINK_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 발급] 발급할 쿠폰 리스트 가져오기
   */
  yield takeEvery(couponAction.GET_ISSUED_COUPON_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getGenerateSearchCouponList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_ISSUED_COUPON_LIST_REQUEST_SUCCESS);

        const data = {
          couponList: setResponseListForm(result.data.couponList, result.data.totalCnt, payload),
        };

        yield put({ type: couponAction.GET_ISSUED_COUPON_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_ISSUED_COUPON_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 발급] 쿠폰 발급받을 유저 리스트 요청하기
   */
  yield takeEvery(couponAction.GET_GENERATE_COUPON_USER_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getGenerateSearchUserList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_GENERATE_COUPON_USER_LIST_REQUEST_SUCCESS);
        const data = {
          userList: setResponseListForm(result.data.userList, result.data.totalCnt, payload),
        };
        yield put({ type: couponAction.GET_GENERATE_COUPON_USER_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_GENERATE_COUPON_USER_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 발급] 쿠폰 발급받을 유저 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(couponAction.GET_GENERATE_COUPON_USER_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getGenerateUserListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_GENERATE_COUPON_USER_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('쿠폰 발급받을 유저 리스트', result.data.couponGenerateUserListExcelSheet);
      }
    } catch (error) {
      toastMsg.error(error.message || couponToastMsg.GET_GENERATE_COUPON_USER_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 발급] 쿠폰 발급 준비 데이터 가져오기
   */
  yield takeEvery(couponAction.GET_PREPARATION_GENERATE_COUPON_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getPreparationCouponGenerate, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_PREPARATION_GENERATE_COUPON_REQUEST_SUCCESS);

        const data = {
          issuedCouponList: result.data.issuedCouponList,
          userList: setResponseListForm(result.data.userList, result.data.totalCnt, payload),
        };
        yield put({ type: couponAction.GET_PREPARATION_GENERATE_COUPON_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_PREPARATION_GENERATE_COUPON_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 발급] 검색으로 선택한 쿠폰 리스트 가져오기
   */
  yield takeEvery(couponAction.GET_SEARCH_COUPON_RESULT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getGenerateSearchCouponResult, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_SEARCH_COUPON_RESULT_REQUEST_SUCCESS);

        const data = {
          issuedCouponList: result.data.issuedCouponList,
          selectedCouponIdList: payload.couponIdList,
        };
        yield put({ type: couponAction.GET_SEARCH_COUPON_RESULT_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_SEARCH_COUPON_RESULT_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 발급] 엑셀 일괄 발급 유효성 체크요청하기
   */
  yield takeEvery(couponAction.EXCEL_BULK_GENERATE_COUPON_CHECK_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.excelBulkGenerateCouponCheck, setMultipartForm(payload, true));

      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.EXCEL_BULK_GENERATE_COUPON_CHECK_REQUEST_SUCCESS);

        const { userCouponList, requestCnt, possibleCnt, impossibleCnt, isBulk } = result.data;

        /**
         * 실패건이 하나라도 있는 경우에는 실패 모달로 보낸다.
         */
        if (impossibleCnt > 0) {
          /**
           *  쿠폰 발급 유효 체크 실패 모달 띄우기
           */
          yield put(
            appActions.appToggleModal({
              name: 'generateCouponValidFailModal',
              value: true,
              data: {
                userCouponList,
                requestCnt,
                possibleCnt,
                impossibleCnt,
                isBulk,
              },
            }),
          );
        } else {
          /**
           *  쿠폰 발급 유효 체크 성공 모달 띄우기
           */
          yield put(
            appActions.appToggleModal({
              name: 'generateCouponValidSuccessModal',
              value: true,
              data: {
                userCouponList,
                requestCnt,
                possibleCnt,
                impossibleCnt,
                targetAction: payload.targetAction,
              },
            }),
          );
        }
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.EXCEL_BULK_GENERATE_COUPON_CHECK_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 발급 내역 리스트] 쿠폰 발급 내역 리스트 가져오기
   */
  yield takeEvery(couponAction.GET_COUPON_ISSUE_HISTORY_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponIssueHistoryList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_ISSUE_HISTORY_LIST_REQUEST_SUCCESS);

        const data = {
          couponIssueHistoryList: _setResponseListForm(
            result.data.couponIssueHistoryList,
            result.data.totalCnt,
            payload,
          ),
          adminSelectList: result.data.adminSelectList,
        };

        yield put({ type: couponAction.GET_COUPON_ISSUE_HISTORY_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_ISSUE_HISTORY_LIST_REQUEST_ERROR);
    }
  });

  /**
   * [쿠폰 발급 내역 상세] 쿠폰 발급 내역 상세 가져오기
   */
  yield takeEvery(couponAction.GET_COUPON_ISSUE_HISTORY_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponIssueHistoryDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_ISSUE_HISTORY_DETAIL_REQUEST_SUCCESS);

        const data = {
          couponIssueHistoryDetail: {
            couponIssueHistoryInfo: result.data.couponIssueHistoryInfo,
            couponIssueHistoryItemList: _setResponseListForm(
              result.data.couponIssueHistoryItemList,
              result.data.totalCnt,
              payload,
            ),
          },
        };

        yield put({ type: couponAction.GET_COUPON_ISSUE_HISTORY_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_ISSUE_HISTORY_DETAIL_REQUEST_ERROR);
    }
  });

  /**
   *  [쿠폰 발급 내역 상세] 쿠폰 발급 리스트 가져오기
   */
  yield takeEvery(couponAction.GET_COUPON_ISSUE_HISTORY_COUPON_GENERATED_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CouponApi.getCouponGeneratedList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.GET_COUPON_ISSUE_HISTORY_COUPON_GENERATED_LIST_REQUEST_SUCCESS);

        const data = {
          couponIssueHistoryDetail: {
            couponIssueHistoryItemList: _setResponseListForm(
              result.data.couponIssueHistoryCouponGeneratedList,
              result.data.totalCnt,
              payload,
            ),
          },
        };

        yield put({ type: couponAction.GET_COUPON_ISSUE_HISTORY_COUPON_GENERATED_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(couponToastMsg.GET_COUPON_ISSUE_HISTORY_COUPON_GENERATED_LIST_REQUEST_ERROR);
    }
  });
}

export default function* couponSaga() {
  yield fork(fetchList);
}
